import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Dominio } from "src/app/model/dominio-operacao.model";
import { MODALIDADES_ACEITAS_ABA_OUTRAS_GARANTIAS } from "src/app/model/modalidade_garantia.model";
import { HistoricoOperacaoCreditoLivre, OperacaoCreditoLivre, OutrasGarantias } from "src/app/model/operacao-credito-livre.model";
import { LiberacaoOperacaoGarantida, OperacaoGarantida } from "src/app/model/operacao-garantida.model";
import { COMPOSICAO_GARANTIA, OperacaoRepasseBndes, PRINCIPAL_GARANTIA_OPERACAO } from "src/app/model/operacao-repasse-bndes.model";

@Component({
    selector: 'aba-outras-garantias',
    templateUrl: 'aba-outras-garantias.component.html',
    standalone: false
})
export class AbaOutrasGarantiasComponent implements OnChanges {
    @Input()
    public operacao: OperacaoCreditoLivre;
    @Input()
    public model: OperacaoGarantida;
    @Input()
    public modoEdicao: Boolean;
    @Input()
    public modoAditivo: Boolean;
    @Input()
    public emInclusao: Boolean;
    @Input()
    public dadosDominio: Dominio;

    public outrasGarantias: OutrasGarantias[];
    public composicaoGarantia: any[] = COMPOSICAO_GARANTIA;
    public codigoComposicaoGarantia: string = "";
    public principalGarantiaOperacao: any[] = PRINCIPAL_GARANTIA_OPERACAO;
    public codigoPrincipalGarantiaOperacao: number;
    public percentualCobertoGarantiaPrincipal: number;

    public modalidadeAceita: Boolean = false;

    ngOnChanges(changes: SimpleChanges): void {
        this.outrasGarantias = this.operacao.outrasGarantias;
        this.modalidadeAceita = [
            MODALIDADES_ACEITAS_ABA_OUTRAS_GARANTIAS.FGT, 
            MODALIDADES_ACEITAS_ABA_OUTRAS_GARANTIAS.FGBS
          ].includes(this.model.modalidadeFGI);

        if(this.modalidadeAceita) {
            const operacaoRepasse: OperacaoRepasseBndes = <OperacaoRepasseBndes>this.model;
            this.codigoComposicaoGarantia = operacaoRepasse.composicaoGarantia;
            if(this.codigoComposicaoGarantia === undefined || this.codigoComposicaoGarantia === null) {
                this.composicaoGarantia = null;
            }

            this.codigoPrincipalGarantiaOperacao = operacaoRepasse.principalGarantiaOperacao;
            if(this.codigoPrincipalGarantiaOperacao === undefined || this.codigoPrincipalGarantiaOperacao === null) {
                this.principalGarantiaOperacao = null;
            }
            
            this.percentualCobertoGarantiaPrincipal = operacaoRepasse.percentualCobertoGarantiaPrincipal;
        }
    }

    adicionarGarantia() {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
        operacaoCreditoLivre.outrasGarantias.push(new OutrasGarantias());
    }

    removerGarantia(i) {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
        operacaoCreditoLivre.outrasGarantias.splice(i, 1);
    }

    atribuiGarantia(tipoGarantia: string, i) {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
        operacaoCreditoLivre.outrasGarantias[i].tipoGarantia = tipoGarantia;
    }
}